import React from 'react'
import styled, { css } from 'styled-components'
import AskList from '../components/health/ask-list'
import { BottomSection, TopSection } from '../components/page-layouts/two-section-page'
import Container from '../components/system/container/container'
import PACHero from '../components/system/generic-hero/pac-hero'
import Layout from '../components/system/layout'
import Meta from '../components/system/meta'
import { HealthAsk, HealthAskType } from '../models/health-ask'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import { withApollo } from '../apollo/apollo'

const StyledTopSection = styled(TopSection)`
  margin-bottom: ${props => props.theme.spacing.base700};
`

const IntroDescription = styled.p`
  margin-top: ${props => props.theme.spacing.base600};
`

const WhatWeAskOfYouH2 = styled.h2`
  margin-top: 0;
`

const Hr = styled.hr`
  margin: ${props => props.theme.spacing.base600} 0;
  ${({ color }: { color: 'light' | 'dark' }) =>
    color === 'light' &&
    css`
      color: #ffffff;
      opacity: 0.3;
    `}
`

const HEALTH_ASKS = gql`
  query HealthAsks {
    allHealthAsks {
      title
      message
      icon
      type
    }
  }
`

const Health = () => {
  const { data, loading, error } = useQuery(HEALTH_ASKS)

  if (!data || !data.allHealthAsks) {
    return <div>Unable to load health data.</div>
  }

  const healthAsks: HealthAsk[] = data.allHealthAsks

  const whatWeAskOfYou = healthAsks.filter(ask => ask.type === HealthAskType.WhatWeAskOfYou)
  const whatYouCanExpectFromUs = healthAsks.filter(
    ask => ask.type === HealthAskType.WhatYouCanExpectFromUs
  )

  return (
    <Layout>
      <Meta title="Health &amp; Safety" />
      <PACHero>
        <h1>
          <b>Health</b> &amp; Safety
        </h1>
      </PACHero>
      <StyledTopSection>
        <Container>
          <section>
            <h2>A safe performance, on and off the stage</h2>
            <IntroDescription>
              The Allen Performing Arts Center is excited to welcome you back to our venues. The
              safety of our audiences, performers and staff is our utmost priority. We have put in
              place a number of new measures as part of our COVID-safe reopening plan, and we thank
              you in advance for your cooperation and patience.
            </IntroDescription>
          </section>
          <Hr color="dark" />
          <section>
            <WhatWeAskOfYouH2>What we ask of you</WhatWeAskOfYouH2>
            <AskList asks={whatWeAskOfYou} color="dark" />
          </section>
        </Container>
      </StyledTopSection>
      <BottomSection>
        <Container>
          <section>
            <h2>What you can expect from us</h2>
            <AskList asks={whatYouCanExpectFromUs} color="light" />
          </section>
          <Hr color="light" />
          <section>
            <p>
              If you, or anyone in your household or support bubble is feeling unwell or has
              displayed any symptoms of COVID-19 in the 10 days prior to your visit, please stay at
              home and follow health guidelines. Our friendly team will help you re-arrange your
              visit. Simply contact tickets@allenpac.org. We look forward to seeing you and enjoy
              the show!
            </p>
          </section>
        </Container>
      </BottomSection>
    </Layout>
  )
}

export default withApollo(Health)
